import { FC } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import Thumbnail from "./Thumbnail";
import TagChip from "../../../../components/ui/TagChip";
import { TutorialModel } from "../../../../models/TutorialModel";
import { formatDuration } from "../../../../utils/duration";

type Props = {
  tutorial: TutorialModel;
  onPlay: () => void;
};

/** Card de tutorial na grade. */
const TutorialCard: FC<Props> = ({ tutorial, onPlay }) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onPlay}
      sx={{
        backgroundColor: "background.paper",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "14px",
        overflow: "hidden",
        cursor: "pointer",
        height: "100%",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        transition: "box-shadow 0.18s, border-color 0.18s",
        "&:hover": { borderColor: theme.palette.brand.creamStroke, boxShadow: theme.customShadows.card },
      }}
    >
      <Box sx={{ flex: { md: "0 0 52%" }, minWidth: 0 }}>
        <Thumbnail videoId={tutorial.url} isNew={tutorial.new_icon} size="hero" />
      </Box>

      <Box sx={{ p: { xs: "14px 16px 16px", md: "24px 28px" }, flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Typography
          sx={{
            fontSize: 14.5,
            fontWeight: 600,
            color: "text.primary",
            lineHeight: 1.4,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            mb: 0.5,
          }}
        >
          {tutorial.title}
        </Typography>
        {tutorial.subtitle && (
          <Typography sx={{ fontSize: 12, color: "text.secondary", lineHeight: 1.5 }}>{tutorial.subtitle}</Typography>
        )}
        {(tutorial.category || tutorial.durationSeconds != null) && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, flexWrap: "wrap" }}>
            {tutorial.category && <TagChip label={tutorial.category} />}
            {tutorial.durationSeconds != null && (
              <Typography component="span" sx={{ fontSize: 11, fontWeight: 500, color: "text.secondary" }}>
                {formatDuration(tutorial.durationSeconds)}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TutorialCard;
